import type { LocationToolsContentViewModel } from "./useLocationToolsContentModel";

export function LocationToolsAddTypeModal({ vm }: { vm: LocationToolsContentViewModel }) {
  const { showAddTypeModal, setShowAddTypeModal, newTypeLabel, setNewTypeLabel, newTypeDescription, setNewTypeDescription, addLinkType } =
    vm;

  if (!showAddTypeModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40" role="dialog">
      <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-600 p-4 max-w-md w-full shadow-xl space-y-3">
        <div className="font-semibold text-gray-900 dark:text-gray-100">New link type</div>
        <label className="block text-sm">
          Label
          <input
            className="mt-1 w-full rounded-lg border border-gray-200 dark:border-gray-600 px-3 py-2 text-sm"
            value={newTypeLabel}
            onChange={(e) => setNewTypeLabel(e.target.value)}
            placeholder="e.g. Parts ordering portal"
          />
        </label>
        <label className="block text-sm">
          Description
          <input
            className="mt-1 w-full rounded-lg border border-gray-200 dark:border-gray-600 px-3 py-2 text-sm"
            value={newTypeDescription}
            onChange={(e) => setNewTypeDescription(e.target.value)}
            placeholder="Short hint for your team"
          />
        </label>
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" className="px-3 py-2 text-sm rounded-lg border border-gray-200" onClick={() => setShowAddTypeModal(false)}>
            Cancel
          </button>
          <button
            type="button"
            className="px-3 py-2 text-sm rounded-lg bg-indigo-600 text-white"
            onClick={addLinkType}
            disabled={!newTypeLabel.trim()}
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
}
